import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const PAGES = {
  "/": "Home",
  "/programs": "Programs",
  "/programs/:id": "Program Details",
  "/my-programs": "My Programs",
  "/about": "About Us",
  "/contact": "Contact Us",
  "/legal": "Legal Compliance",
  "/blogs": "Blogs",
  "/blogs/:id": "Blog Details"
};

let clickTrackingInitialized = false;

const handleDocumentClick = (e) => {
  const target = e.target;

  if (!(target instanceof Element)) return;

  const element = target.closest("button, a");

  if (!element) return;

  console.log("CLICK DETECTED:", element);

  trackEvent("click_event", {
    element_name:
      element.dataset.gaEvent ||
      element.getAttribute("aria-label") ||
      element.getAttribute("title") ||
      element.id ||
      element.getAttribute("name") ||
      element.textContent?.trim() ||
      element.getAttribute("href") ||
      "",

    element_type: element.tagName.toLowerCase(),

    page: getPageData(window.location.pathname),

    text: element.textContent?.trim() || "",
  });
};

const initializeClickTracking = () => {
  if (clickTrackingInitialized) return;

  document.addEventListener("click", handleDocumentClick);
  clickTrackingInitialized = true;
};

const destroyClickTracking = () => {
  if (!clickTrackingInitialized) return;

  document.removeEventListener("click", handleDocumentClick);
  clickTrackingInitialized = false;
};

export const setUserContext = (user = null) => {
  if (!user) return;

  ReactGA.set({
    user_id: user.id,
  });

  // ReactGA.gtag("set", "user_properties", {
  //   membership: user.membership,
  //   login_method: user.loginMethod,
  // });
};

export const clearUserContext = () => {
  ReactGA.set({
    user_id: null,
  });

  // ReactGA.gtag("set", "user_properties", {});
};

export const initializeAnalytics = () => {
  ReactGA.initialize(MEASUREMENT_ID);
  initializeClickTracking();
};

export const destroyAnalytics = () => {
  destroyClickTracking();
}

export const trackPageView = (path, title) => {
  ReactGA.send({
    hitType: "pageview",
    page: title?'home': path,
    title: title
  });
};

export const trackEvent = (eventName, params = {}) => {
  ReactGA.event(eventName, params);
};

const getPageData = (path) => {
  if(path && path.indexOf('/blogs/') !== -1) {
    return PAGES['/blogs/:id'] || path;
  }
  if(path && path.indexOf('/programs/') !== -1) {
    return PAGES['/programs/:id'] || path;
  }
  return PAGES[path] || path;
};

export const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    let pageData = getPageData(location.pathname);
    trackPageView(location.pathname, pageData);
  }, [location.pathname, location.search]);

  return null;
}

